import React from 'react';
import { MailIcon, GlobeIcon, InstagramIcon } from 'lucide-react';
export function FooterSection() {
  return <footer className="bg-[#0a0a0a] border-t border-purple-500/20 py-12 px-4" data-id="element-122" data-mp="337y793j7iwpv">
      <div className="max-w-3xl mx-auto text-center" data-id="element-123" data-mp="3h9anzh66z2ct">
        {/* Brand */}
        <h3 className="text-2xl md:text-3xl font-black text-white uppercase tracking-wide mb-3" data-id="element-124" data-mp="3c9o9z5ijhi2y">
          💰 DOMINANDO SHOPIFY™
        </h3>
        <p className="text-gray-400 text-base md:text-lg mb-2" data-id="element-125" data-mp="2ol522r3ej7be">
          El programa N°1 para crear y vender productos digitales con Shopify en
          Argentina.
        </p>
        <p className="text-[#FC9DFF] italic text-sm md:text-base font-medium mb-8" data-id="element-126" data-mp="2yag8g5ywlxvl">
          Porque tu libertad financiera no debería costarte años de frustración.
        </p>

        {/* Contact Info */}
        <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-6 mb-8 text-sm md:text-base" data-id="element-127" data-mp="25su338bvbtik">
          <a href="mailto:soporte@brendamelisah.com" className="inline-flex items-center gap-2 text-gray-300 hover:text-[#FC9DFF] transition-colors" data-id="element-128" data-mp="20tr7sflox1ns">
            <MailIcon className="w-4 h-4" data-id="element-129" data-mp="1lerg2bazlg7n" />
            soporte@brendamelisah.com
          </a>
          <span className="hidden md:inline text-gray-600" data-id="element-130" data-mp="1q69i72oqxmu7">•</span>
          <a href="https://www.instagram.com/brendamelisah" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-gray-300 hover:text-[#FC9DFF] transition-colors" data-id="element-131" data-mp="1v5me0cxli48x">
            <InstagramIcon className="w-4 h-4" data-id="element-132" data-mp="12hgshnypwb81" />
            @brendamelisah
          </a>
          <span className="hidden md:inline text-gray-600" data-id="element-133" data-mp="17f8mcnixa7ev">•</span>
          <a href="https://www.instagram.com/dominandoshopify" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-gray-300 hover:text-[#FC9DFF] transition-colors" data-id="element-134" data-mp="1bi4x5s280z89">
            <InstagramIcon className="w-4 h-4" data-id="element-135" data-mp="2myv63iy1455k" />
            @dominandoshopify
          </a>
          <span className="hidden md:inline text-gray-600" data-id="element-136" data-mp="nq7dkr5xvgoo">•</span>
          <a href="https://dominandoshopify.brendamelisah.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-gray-300 hover:text-[#FC9DFF] transition-colors" data-id="element-137" data-mp="irw2ye7tl25e">
            <GlobeIcon className="w-4 h-4" data-id="element-138" data-mp="4419uwpwgvrs" />
            dominandoshopify.brendamelisah.com
          </a>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-800 pt-6" data-id="element-139" data-mp="3r15caq3r98">
          <p className="text-gray-500 text-sm mb-2" data-id="element-140" data-mp="dtkr5xxyshkj">
            © Dominando Shopify™ 2026 — Todos los derechos reservados.
          </p>
          <p className="text-gray-600 text-xs" data-id="element-141" data-mp="92cgyzot8s6b">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}